import React from "react";
import FilterOptions from "./FilterOptions";
import { vyrillDataFilterNames } from "../../constants";
import { ChevronDown, ChevronUp, ChevronRight } from "react-feather";
import { Container, Row, Col } from "reactstrap";

const Filter = ({
  filters,
  selectedFilters,
  name,
  open,
  openFilter,
  closeFilters,
  updateFilters,
  updateSubFilters,
  updateParentTopics,
  subFilter,
  isTopic,
  icon,
  loading,
  disabled,
  showIndicators,
  topics,
  topicFilters,
}) => {
  if (disabled) {
    return (
      <div className="filters-section disabled">
        <div className="filters-header">
          {/* <i className="icon-caret-up" /> */}
          <ChevronUp size={15} />
          {icon}
          <span>
            {vyrillDataFilterNames.includes(name.replace("_", " "))
              ? `${name.replace("_", " ")} - Vyrill Data`
              : name.replace("_", " ")}
          </span>
        </div>
      </div>
    );
  }

  if (!loading && filters && filters.length < 1) {
    return null;
  }

  /* if (name === 'audio_labels') {
    console.log(name);
    console.log(filters);
  } */

  const renderTopicFilters = () => {
    if (topicFilters && topicFilters.includes(name)) {
      return (
        <input
          style={{ marginRight: "5px" }}
          type="checkbox"
          value={name}
          checked={
            selectedFilters &&
            selectedFilters.topics &&
            selectedFilters.topics.includes(name)
          }
          onChange={updateParentTopics}
          onClick={updateFilters}
        />
      );
    }

    if (!subFilter) {
      return icon;
    }

    return null;
  };

  return (
    <div className={`filters-section${subFilter ? " sub" : ""}`}>
      <div
        className={`d-flex align-items-center filters-header${
          subFilter ? " sub" : ""
        }`}
        onClick={open ? closeFilters : openFilter}
      >
        {subFilter ? null : open ? (
          <ChevronDown size={18} />
        ) : (
          <ChevronRight size={18} />
        )}{" "}
        {renderTopicFilters()}
        <span style={{ marginLeft: "4px" }}>
          {vyrillDataFilterNames.includes(name.replace("_", " "))
            ? `${name.replace("_", " ")} - Vyrill Data`
            : name.replace("_", " ")}
        </span>
      </div>

      {open && (
        <FilterOptions
          name={name}
          filters={filters}
          selectedFilters={selectedFilters}
          updateFilters={updateFilters}
          updateSubFilters={updateSubFilters}
          updateParentTopics={updateParentTopics}
          showIndicators={showIndicators}
          topicFilters={topicFilters}
        />
      )}
    </div>
  );
};

export default Filter;
